import { useContext } from "react";
import AlertContext from "../../context/Alert/AlertContext";

const AlertData = () => useContext(AlertContext);

export default AlertData;
